import { render, staticRenderFns } from "./MemberBuy.vue?vue&type=template&id=0b47aadc&scoped=true"
import script from "./MemberBuy.vue?vue&type=script&lang=js"
export * from "./MemberBuy.vue?vue&type=script&lang=js"
import style0 from "./MemberBuy.vue?vue&type=style&index=0&id=0b47aadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b47aadc",
  null
  
)

export default component.exports